import React from 'react';
import GlobalModal from '../../../../../components/modals/modal';
import CreatePartner from '../../../../farm/humans/partners/create-partner';

interface Props {
  onClose: () => void;
}
export default function AddPartnerModal({ onClose }: Props) {
  const body = (
    <CreatePartner closeInstead={true} customHeader={true} horizontal={true} />
  );

  return (
    <GlobalModal
      className="modal-partner"
      visible={true}
      buttons={null}
      body={body}
      onClose={onClose}
      shouldCloseOnOverlayClick={false}
      overlayColor="rgba(188, 185, 232, 0.35)"
    />
  );
}
